import React from 'react'
import SubLayout from '../../components/Layout/SubLayout';
import strings from "../../components/Language";

//  CSS
import './../../assets/styles/style.scss';

import { Link } from 'react-router-dom';
import { IconChevronRight, IconCopy } from '../../components/Icons';
import './wallet.scss';
import QRCode from "react-qr-code";

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import LoaderContext from '../../components/Loader/LoaderContext.js';

class DepositScreen extends React.Component {
    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            access_token: "",
            data: []
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                this.getData();
            });
        }
    }

    copyLink() {
        if ((this.state.data && this.state.data.deposit && this.state.data.deposit.in_wallet) ? this.state.data.deposit.in_wallet : '') {
            navigator.clipboard.writeText((this.state.data && this.state.data.deposit && this.state.data.deposit.in_wallet) ? this.state.data.deposit.in_wallet : '');
            toast.success(strings.code_copy_successfully);
        } else {
            toast.error(strings.wallet_address_not_foud);
        }
    }

    getData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'GET',
                url: api.deposit_bep20,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({ data: ress.data.data });
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                setLoading(false);
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    render() {
        const address = (this.state.data && this.state.data.deposit && this.state.data.deposit.in_wallet) ? this.state.data.deposit.in_wallet : '';

        return (
            <SubLayout data={{ "title": strings.deposit }}>
                <div className='wl-page offset-md-4 col-md-4'>
                    <div className='wl-toolbar'>
                        <span className='wl-chip'><span className='wl-chip-label'>{strings.chain_name}</span> BEP20</span>
                        <Link to={"/deposit-details"} className='wl-link-chip'>
                            {strings.deposit_details}<IconChevronRight size={14} strokeWidth={2.2} />
                        </Link>
                    </div>

                    <section className='wl-card wl-deposit'>
                        <div className='wl-card-title'>{strings.USDT_deposit_address}</div>
                        <div className='wl-qr'>
                            <QRCode value={address} size={184} />
                        </div>
                        <div className='wl-hint'>{strings.address_can_only_receive_USDT}</div>

                        <div className='wl-address'>
                            <span className='wl-address-text'>{address || '-'}</span>
                            <button type="button" className='wl-icon-btn' onClick={() => this.copyLink()} aria-label={strings.code_link}>
                                <IconCopy size={18} />
                            </button>
                        </div>

                        <button type="button" className="m-btn m-btn-primary wl-cta" onClick={() => this.copyLink()}>
                            {strings.code_link}
                        </button>
                    </section>

                    <div className='m-note wl-note'>
                        <div className='m-note-title'>{strings.risk_disclaimer}</div>
                        <div>{strings.deposit_risk_disclaimer_point_1}</div>
                        <div>{strings.deposit_risk_disclaimer_point_2}</div>
                        <div>{strings.deposit_risk_disclaimer_point_3}</div>
                    </div>
                </div>
            </SubLayout>
        );
    }
}

export default DepositScreen;
